// 引入各个reducer
import common from './common';
import login from './login';

import taskManageList from './taskManage/list';
import taskManageDetail from './taskManage/detail';
import taskManageMonitoring from './taskManage/monitoring';
import taskManageQuestionNaire from './taskManage/questionNaire';
import taskManageInteractivePath from "./taskManage/interactivePath"

import systemSettingWorkTime from './systemSetting/workTime';
import systemSettingTalkingSkill from './systemSetting/talkingSkill';
import systemSettingCallingNumber from './systemSetting/callingNumber';
import systemSettingExportTasks from './systemSetting/exportTasks';
import systemUserManagement from './systemSetting/userManagement';
import systemSettingNewRole from './systemSetting/newRole';

import enterpriseConfig from './ai/enterpriseConfig';

import aiQuestionStudy from './ai/questionStudy';

const reducers = {
  common,
  login,
  taskManageList,
  taskManageMonitoring,
  taskManageDetail,
  taskManageQuestionNaire,
  systemSettingWorkTime,
  systemSettingTalkingSkill,
  systemSettingCallingNumber,
  systemSettingExportTasks,
  systemUserManagement,
  systemSettingNewRole,
  aiQuestionStudy,
  enterpriseConfig,
  taskManageInteractivePath,
};

export default reducers;
